import { useCallback } from 'react';

import type {
  AlgoliaCardIndexesName,
  GallerySortName,
  PrintablePlayerSortName,
} from '#src/contexts/config/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

import { useGetInteractionContext } from './useGetInteractionContext.ts';
import { LIFECYCLE, useLifecycle } from './useLifecycle.ts';

export const useMarketplaceLifecycle = () => {
  const { sport } = useSportContext();
  const { update, lifecycle } = useLifecycle();
  const getInteractionContext = useGetInteractionContext();

  const key = `${
    sport ? sport.toLocaleLowerCase() : ''
  }_${getInteractionContext()}`;

  const updateSort = useCallback(
    (
      sort:
        | AlgoliaCardIndexesName
        | GallerySortName
        | PrintablePlayerSortName
        | PrintablePlayerSortName[]
    ) => {
      update(LIFECYCLE.marketSorts, {
        ...lifecycle?.marketSorts,
        [key]: sort,
      });
    },
    [update, lifecycle?.marketSorts, key]
  );

  return {
    sort: lifecycle?.marketSorts?.[key] as
      | AlgoliaCardIndexesName
      | GallerySortName
      | PrintablePlayerSortName
      | PrintablePlayerSortName[]
      | undefined,
    updateSort,
  };
};
